import * as RS from 'redux-saga'
import {
  WEB_GET_ACTIVITY_THEMES,
  WEB_REFETCH_ACTIVITY_THEMES,
  setActivityThemesAction,
  getActivityThemesFailedAction
} from './ActivityTheme.Actions';
import {  ActivityThemeService} from './ActivityTheme.Service'
import { IActivityThemeModel } from './ActivityTheme';
import { AxiosPromise, AxiosResponse } from 'axios';
import { keepLocal, AppAction, store } from 'src';
import { setIsLoading, ACTIVITY_LOADING, ACTIVITY_THEME_LOADING } from '../PortalLoadingState/PortalLoadinState.Actions';



function* fetchActivityThemes(action: AppAction<any>){
    store.dispatch(setIsLoading(ACTIVITY_THEME_LOADING, true))
    try{
        let responseData: AxiosResponse<IActivityThemeModel[]>;
        if(!keepLocal){
            responseData =yield RS.effects.call(ActivityThemeService.getActivityThemes)

        }else{

            responseData = yield RS.effects.call(ActivityThemeService.GetLocalActivityThemes)
        }
        yield RS.effects.put(setActivityThemesAction(responseData.data));
    } catch (error){
        yield RS.effects.put(getActivityThemesFailedAction(error.message))
    } finally{
        store.dispatch(setIsLoading(ACTIVITY_THEME_LOADING, false))
    }
}

function* refetchActivityThemes(action: AppAction<any>){
  try{
      let responseData: AxiosResponse<IActivityThemeModel[]>;
      if(!keepLocal){
          responseData =yield RS.effects.call(ActivityThemeService.getActivityThemes)

      }else{

          responseData = yield RS.effects.call(ActivityThemeService.GetLocalActivityThemes)
      }
      yield RS.effects.put(setActivityThemesAction(responseData.data));
  } catch (error){
      yield RS.effects.put(getActivityThemesFailedAction(error.message))
  }
}

export function* GetActivityThemes(){
    yield RS.effects.takeLatest(WEB_GET_ACTIVITY_THEMES, fetchActivityThemes);
    yield RS.effects.takeLatest(WEB_REFETCH_ACTIVITY_THEMES, refetchActivityThemes);
}



// WEBPACK FOOTER //
// ./src/Entities/ActivityTheme/ActivityTheme.Saga.ts